import { arrayMove } from '@dnd-kit/sortable'

type ArrayKeys<T> = {
  [K in keyof T]: T[K] extends Array<any> ? K : never
}[keyof T]

export const reorderData = <T>({
  data,
  activeIndex,
  overIndex,
  sortableKey,
}: {
  data: T | undefined
  activeIndex: number
  overIndex: number
  sortableKey: ArrayKeys<T>
}) =>
  (data
    ? {
        ...data,
        [sortableKey]: arrayMove(data[sortableKey] as unknown as any[], activeIndex, overIndex),
      }
    : data) as T
